import { RootState } from "app/store";

export const selectEmail = (state: RootState) => state.verifyUser.apps.email;
export const selectCode = (state: RootState) => state.verifyUser.apps.code;
export const selectExecuteState = (state: RootState) =>
  state.verifyUser.apps.executeState;
